import isPropValid from '@emotion/is-prop-valid';
import styled from '@emotion/styled';
import { Grid } from '@material-ui/core';
import { Magnetic } from '../../styles';
export const GalleryWrapper = styled(Grid, {
    shouldForwardProp: prop => isPropValid(prop) && prop != 'isSelectModeOn'
}) `
	display: inline-block;
	width: 100%;
	background-color: ${(props) => props.isSelectModeOn ? `${Magnetic.colorMocha30}` : `transparent`};

	${(props) => props.isSelectModeOn ? `transition: background-color 1s linear` : ''};
`;
export const NoAttachments = styled('div') `
	left: 0;
	top: 0;
	height: ${Magnetic.spacer48} ${Magnetic.spacer08};
	background-color: ${Magnetic.colorNeutral5};
	box-sizing: ${Magnetic.formControlCoreBoxSizing};
	border: ${Magnetic.baseBorderWidth} ${Magnetic.baseBorderStyle} ${Magnetic.colorNeutral30};
	border-left: 0;
	border-right: 0;
	border-radius: 0;
	box-shadow: none;
	font-size: ${Magnetic.fontSize16};
	color: ${Magnetic.colorNeutral50};
	padding: ${Magnetic.spacer08};
	padding-bottom: ${Magnetic.spacer48};
	text-align: center;
`;
export const SimpleGalleryWrapper = styled(Grid) `
	padding: ${Magnetic.spacer06};
`;
//# sourceMappingURL=style.js.map